import { Component, OnInit } from '@angular/core';
import { InformationPageService } from 'src/app/services/informationPage.service';
import { Router } from '@angular/router';
import { InformationPage } from 'src/app/intefaces/information-page.interface';

@Component({
  selector: 'information-pages',
  templateUrl: './information-pages.component.html',
  styleUrls: ['./information-pages.component.scss']
})
export class InformationPagesComponent implements OnInit {

  informationPages: InformationPage[];

  constructor(private informationPageService: InformationPageService, private router: Router) { }

  ngOnInit(): void {
    this.informationPageService.getAllInformationPages().subscribe((response: any) => {
      this.informationPages = response.data.pages;
    });
  }

  public onEditInformationPage(id: number, lang: string, desc: string) {
    this.router.navigate(['/administrator-panel/information-page-editor', id, lang, desc])
  }

}